import { Quote } from '../../Quote'
import { Section } from '../../Section'

export default function QuoteSection({ quotation, quoteBy }) {
    return (
        <Section py={15} bg="#0d417d">
            <Quote color="#fff" quotation={quotation} quoteBy={quoteBy} />
        </Section>
    )
}
